import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { ApplicationPipelineReportPayload } from '~bank-reports/types/ApplicationPipelineReport'

export const applicationPipelineReportQueryOptions = (deps: Partial<ApplicationPipelineReportPayload>) =>
  queryOptions({
    queryKey: ['applicationPipelineReport', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportApplicationPipeline, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
